import {
	AbstractControl,
	NG_VALIDATORS,
	ValidationErrors,
	Validator
} from '@angular/forms';
import {
	Directive,
	Input
} from '@angular/core';
import { get } from 'lodash';

@Directive({
	selector: '[commonMatch]',
	providers: [{
		provide: NG_VALIDATORS,
		useExisting: CommonMatchValidatorDirective,
		multi: true,
	}],
})
export class CommonMatchValidatorDirective implements Validator {
	@Input() commonMatch: string;

	validate (control: AbstractControl): ValidationErrors | null {
		const matchControl = control.root.get(this.commonMatch);
		let res;

		if (matchControl) {
			const changeSubscription = matchControl.valueChanges.subscribe(() => {
				control.updateValueAndValidity();
				changeSubscription.unsubscribe();
			});

			res = get(matchControl, 'value') !== control.value;
			control.setErrors(res ? {CommonMatchValidator: true} : null);
		}

		return res ? {
			match: true,
		} : null;

	}
}
